<div class="flex mb-4"
     [ngClass]="{'justify-end': message.sender === 'user', 'justify-start': message.sender === 'assistant'}">
  <button *ngIf="message.sender === 'assistant'" mat-icon-button class="bg-yellow-#FF6D03 mr-2">
    <mat-icon class="text-white">smart_toy</mat-icon>
  </button>

  <div
    class="px-4 py-2 rounded-lg max-w-[70%]"
    [ngClass]="{
                  'bg-[#FF6D03] text-gray': message.sender === 'user',
                  'bg-white border border-gray-200 text-gray-800': message.sender === 'assistant'
                }"
  >
    <ng-container *ngIf="message.isTyping">{{ typingDots }}</ng-container>
    <ng-container *ngIf="!message.isTyping">
      <ng-container *ngFor="let part of parsedContent">
        <ng-container *ngIf="isString(part)">{{ part }}</ng-container>
        <app-fence-block *ngIf="!isString(part)" [block]="part"></app-fence-block>
      </ng-container>
    </ng-container>
  </div>

  <button *ngIf="message.sender === 'user'" mat-icon-button class="bg-gray-300 ml-2">
    <mat-icon class="text-white">person</mat-icon>
  </button>
</div>
